<template lang="pug">
//- 直播再現
.live-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .live-title 直播再現

  //- 團班課表
  LiveTimeTableArea(:coursetable_data="coursetable_data")
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
import LiveTimeTableArea from '@/components/livemain/live-timetable-area'
export default {
  coures_teacher: {
    name: 'Index',
  },
  components: {
    ContentTop,
    LiveTimeTableArea
  },
  data () {
    return {
      //- 課程data
      coursetable_data: {},
      //- 自動化設定畫面方向
      autoSetScreen: false,
      //- Banner 清單 
      banners: []


    };
  },
  async created () {
    this.$root.closeLoading()
  },
  mounted () {
  },
  computed: {
  },
  methods: {

  }
}
</script>
<style lang="sass">
</style>
